
export function handleResponse(response) {
    return { ok: true, response }
}

export function handleError(error) {

    if( !error.response ) { 
        return { 
            ok: false, 
            msg: 'Hubo un error en en el servidor intenta de nuevo más tarde', 
            response: error.response 
        } 
    }

    if (error.response.status === 404 || error.response.status === 500) {
        return { 
            ok: false,
            msg: 'Hubo un problema al conectar con el servidor, informa al administrador. Error: ' + error.response.status,
            response: error.response
        }
    }

    return { 
        ok: false, 
        msg: 'Revisa tu información antes de continuar',
        errores: error.response.data.errores,
        response: error.response 
    };
}

export function handleDownload( response ) {
    return response
}